import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { Shell } from './app/shell/shell';

// Starts the icon font download now rather than at first render, and marks
// the page once it is in — nv-icon hides its ligature text until then (see
// nv-icon.ts and the font link in index.html).
document.fonts
  ?.load('400 24px "Material Symbols Rounded"', 'home')
  .then((faces) => {
    if (faces.length) document.documentElement.classList.add('nv-icons-ready');
  })
  .catch(() => undefined);

bootstrapApplication(Shell, appConfig)
  .catch((err) => console.error(err));
